import { VerticalTimeline } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { Loader2, History } from 'lucide-react';
import { ActivityLog } from './types';
import { ActivityTimelineItem } from './ActivityTimelineItem';

interface ActivityTimelineProps {
  logs: ActivityLog[];
  loading?: boolean;
  showEntityBadge?: boolean;
  emptyMessage?: string;
  className?: string;
}

export function ActivityTimeline({
  logs,
  loading = false,
  showEntityBadge = true,
  emptyMessage = 'No activity recorded yet',
  className = '',
}: ActivityTimelineProps) {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (logs.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-muted-foreground">
        <History className="h-12 w-12 mb-3 opacity-50" />
        <p className="text-sm">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={`activity-timeline ${className}`}>
      <style>{`
        .vertical-timeline {
          padding: 0 !important;
          width: 100% !important;
          max-width: 100% !important;
        }
        .vertical-timeline::before {
          background: hsl(var(--border)) !important;
          width: 2px !important;
          left: 18px !important;
        }
        .vertical-timeline-element {
          margin: 1rem 0 !important;
        }
        .vertical-timeline-element-content {
          margin-left: 45px !important;
          padding: 1rem !important;
        }
        .vertical-timeline-element-icon {
          width: 28px !important;
          height: 28px !important;
          left: 5px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        .vertical-timeline-element-date {
          display: none !important;
        }
        .vertical-timeline-element-content-arrow {
          display: none !important;
        }
        @media (min-width: 1170px) {
          .vertical-timeline::before {
            left: 18px !important;
          }
          .vertical-timeline-element-content {
            margin-left: 45px !important;
            width: calc(100% - 50px) !important;
          }
          .vertical-timeline-element-icon {
            left: 5px !important;
          }
        }
      `}</style>
      <VerticalTimeline layout="1-column-left" lineColor="hsl(var(--border))">
        {logs.map((log) => (
          <ActivityTimelineItem
            key={log.id}
            log={log}
            showEntityBadge={showEntityBadge}
          />
        ))}
      </VerticalTimeline>
    </div>
  );
}
